import { endpoint } from 'services/endpoint';
import { backendHttp } from './backendHttp';
import { normalizeTokenResponse } from './tokenResponse';
import { TAuthTokens, TRawTokenResponse, TTokenClient, TTokenExchangeRequest } from './types';

export const backendTokenClient: TTokenClient = {
	exchangeAuthorizationCode: (payload: TTokenExchangeRequest): Promise<TAuthTokens | null> =>
		backendHttp
			.post<TRawTokenResponse>(endpoint.auth.TOKEN_CODE, payload)
			.then((response) => normalizeTokenResponse(response.data)),

	requestRefreshedTokens: (refreshToken: string): Promise<TAuthTokens | null> =>
		backendHttp
			.post<TRawTokenResponse>(endpoint.auth.REFRESH_TOKEN, { refresh_token: refreshToken })
			.then((response) => normalizeTokenResponse(response.data)),

	endSsoSession: (refreshToken: string, accessToken: string | null): Promise<unknown> =>
		backendHttp.post(endpoint.auth.LOGOUT, null, {
			params: { refreshToken },
			headers: accessToken ? { Authorization: accessToken } : undefined,
		}),
};
